import * as React from "react";
const SideDownArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m10.592 13.464 4.715-4.714-1.179-1.179-4.125 4.125-4.125-4.125L4.7 8.75l4.714 4.714a.833.833 0 0 0 1.178 0Z"
        clipRule="evenodd"
      />
    </g>
    <rect
      width={18}
      height={18}
      x={19}
      y={19}
      stroke="#fff"
      strokeWidth={2}
      rx={5}
      transform="rotate(180 19 19)"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 5v10h20V5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SideDownArrow;
